import { render, staticRenderFns } from "./EditGradualMessageSequence.vue?vue&type=template&id=4c2076af&"
import script from "./EditGradualMessageSequence.vue?vue&type=script&lang=js&"
export * from "./EditGradualMessageSequence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports